import { LegacyPortalSpwnEcService } from "@spwn-portal/grpc";
import useSWR from "swr";
import { createConnectClient } from "utility/connectWeb";

import { toProductData } from "./toProductData";

import type { ProductData } from "@spwn/types/firebase/firestore";

const EMPTY_PRODUCTS: ProductData[] = [];

/**
 * イベントのライブコマース商品を Shopify から取る。
 *
 * 商品一覧 API はログイン必須なので、未ログイン (isLoggedIn=false) のときは
 * 取得せず空にする。オンラインストア非公開の商品も含むため。
 * ID トークンは connect クライアントの interceptor が付ける。
 */
export const useLiveCommerceProducts = (
  eventId: string | undefined,
  isLoggedIn: boolean
): ProductData[] => {
  const { data } = useSWR(
    eventId !== undefined && isLoggedIn
      ? ["liveCommerceProducts", eventId]
      : null,
    async ([, id]: [string, string]) => {
      const client = createConnectClient(LegacyPortalSpwnEcService);
      const response = await client.getAllLiveCommerceProductsByEventId({
        eventId: id,
      });
      return response.products.flatMap((product, index) =>
        toProductData(product, index, id)
      );
    },
    { revalidateOnFocus: false }
  );

  return data ?? EMPTY_PRODUCTS;
};
